import { FunctionComponent } from 'react';
import { InternalNavigationLinkProps } from '../types';

export const InternalNavigationLink: FunctionComponent<InternalNavigationLinkProps> = ({ text, href }) => (
  <a
    className="tou-modal_link"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    {text}
  </a>
);
